import React from 'react';
import { Row, Col, Card, Table } from 'react-bootstrap';
import { CompletionPieChart, AbandonmentChart } from './charts/ResponseCharts';

const CompletionAnalysisTab = ({ stats, survey }) => {
    // Prepare data for the abandonment chart
    const prepareAbandonmentData = () => {
        if (!survey) return [];

        return Object.entries(stats.abandonmentPoints).map(([questionIndex, count]) => ({
            questionNumber: Number(questionIndex) + 1,
            questionText: survey.questions[questionIndex]?.questionText?.substring(0, 30) + '...',
            count
        })).filter(item => item.count > 0);
    };

    return (
        <>
            <Row className="mb-4">
                <Col md={6}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Completion Status</Card.Title>
                            <CompletionPieChart
                                submittedResponses={stats.submittedResponses}
                                incompleteResponses={stats.incompleteResponses}
                            />
                        </Card.Body>
                    </Card>
                </Col>
                <Col md={6}>
                    <Card>
                        <Card.Body>
                            <Card.Title>Survey Abandonment Points</Card.Title>
                            <AbandonmentChart abandonmentData={prepareAbandonmentData()} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>

            <Card className="mb-4">
                <Card.Body>
                    <Card.Title>Abandonment Details</Card.Title>
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>Question #</th>
                            <th>Question Text</th>
                            <th>Abandonments</th>
                            <th>Percentage</th>
                        </tr>
                        </thead>
                        <tbody>
                        {Object.entries(stats.abandonmentPoints)
                            .filter(([_, count]) => count > 0)
                            .sort((a, b) => b[1] - a[1])
                            .map(([questionIndex, count]) => {
                                const questionNumber = parseInt(questionIndex) + 1;
                                const question = survey?.questions[questionIndex];
                                const percentage = ((count / stats.incompleteResponses) * 100).toFixed(1);

                                return (
                                    <tr key={questionIndex}>
                                        <td>{questionNumber}</td>
                                        <td>{question?.questionText}</td>
                                        <td>{count}</td>
                                        <td>{percentage}%</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>
        </>
    );
};

export default CompletionAnalysisTab;